import moment from 'moment';

let timer;

export const startTimer = state => {
  state.time = 0;
  timer = setInterval(() => {
    state.time += 1;
  }, 1000);
  state.startTime = moment();
};

export const stopTimer = () => {
  window.clearInterval(timer);
};
